import React from "react";

import { BirthAtCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function birthAt({ width, onResize }: Column.Options) {
	return base(ColumnId.BirthAt, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default birthAt;
